<template>
  <el-dialog
    title="简答评分"
    :visible.sync="formVisible"
    width="80%"
    :close-on-click-modal="false"
  >
    <el-steps
      :active="active"
      finish-status="success"
      style="width: 400px;margin: 0 auto;"
    >
      <el-step title="老师选择"></el-step>
      <el-step title="试卷评分"></el-step>
    </el-steps>
    <div v-if="active == 0" style="margin: 0 auto;width: 600px;">
      <el-form
        ref="teacherFormRef"
        :model="teacherForm"
        :rules="teacherFormRule"
        label-width="auto"
      >
        <el-form-item label="评分老师" prop="teacher">
          <el-select
            v-model="teacherForm.teacher"
            placeholder=""
            style="width: 100%;"
          >
            <el-option
              v-for="i in teachers"
              :key="i.value"
              :label="i.label"
              :value="i.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div v-else>
      <div class="score-header" v-if="paperData && paperData.length > 0">
        <div class="header-label">评卷老师：</div>
        <div>{{ teacherName.label }}</div>
        <div class="header-label">考生：</div>
        <div>{{ paperData[paperIndex].memberName }}</div>
        <div class="header-label">题目数量：</div>
        <div>{{ paperData[paperIndex].questionList.length || 0 }}</div>
      </div>
      <div
        style="height: 600px;overflow-y: auto;"
        v-if="paperData && paperData.length > 0"
      >
        <div
          v-for="(item, key) in paperData[paperIndex].questionList"
          :key="key"
          class="question-box"
        >
          <div>
            {{ key + 1 }}、（{{ item.questionScore }}分）{{ item.questionStem }}
          </div>
          <div>
            <span style="margin-right: 8px;color: red;">参考答案：</span>
            {{ item.questionAnswer }}
          </div>
          <div>
            <span style="margin-right: 8px;">考生答案：</span>
            {{ item.studentAnswer }}
          </div>
          <div>
            <span style="margin-right: 8px;">评分：</span>
            <el-input-number
              v-model="item.score"
              :precision="1"
              :step="0.1"
              step-strictly
              :min="0"
              :max="Number(item.questionScore)"
            ></el-input-number>
          </div>
        </div>
        <el-button type="primary" style="float:right" @click="handleSubmit"
          >提交评分</el-button
        >
      </div>
    </div>
    <div slot="footer">
      <el-button @click="formVisible = false">关 闭</el-button>
      <el-button type="primary" v-if="active == 0" @click="nextStep">
        下一步
      </el-button>
      <!-- <el-button type="primary" @click="dialogVisible = false" v-else>
        确 定
      </el-button> -->
    </div>
  </el-dialog>
</template>
<script>
import { getShortQsData, handleShortQs } from "@/api/exam";

export default {
  data() {
    return {
      formVisible: false,
      active: 1,
      examData: null,
      teachers: [
        {
          label: "评卷员一",
          value: 1
        },
        {
          label: "评卷员二",
          value: 2
        },
        {
          label: "评卷员三",
          value: 3
        }
      ],
      teacherForm: {
        teacher: 2
      },
      teacherFormRule: {
        teacher: [
          { required: true, message: "请选择", trigger: ["blur", "change"] }
        ]
      },
      paperData: [],
      paperIndex: 0
    };
  },
  computed: {
    teacherName() {
      console.log(this.teachers, this.teacherForm.teacher);
      return this.teachers.find(i => i.value == this.teacherForm.teacher);
    }
  },
  methods: {
    open(row) {
      this.active = 0;
      this.paperIndex = 0;
      this.teacherForm.teacher = null;
      this.examData = row;
      this.formVisible = true;
    },
    async nextStep() {
      const valid = await this.$refs.teacherFormRef.validate();
      if (!valid) return;
      this.active = 1;
      try {
        const res = await getShortQsData({
          examinationCode: this.examData.examinationCode,
          teacherId: this.teacherForm.teacher
        });
        console.log("res.data.data", res.data.data);
        if (res.data.data && res.data.data.length > 0) {
          this.paperData = res.data.data;
        } else {
          this.formVisible = false;
          this.$message({
            message: "无简答数据！",
            type: "warning"
          });
        }
      } catch (e) {
        this.formVisible = false;
      }
    },
    async handleSubmit() {
      // 提交分数接口

      const examCache = this.paperData[this.paperIndex];
      const scoreList = examCache.questionList.map(item => ({
        examinationId: examCache.examinationId,
        memberId: examCache.memberId,
        questionId: item.questionId,
        score: item.score
      }));
      try {
        await handleShortQs({
          teacherId: this.teacherForm.teacher,
          scoreList
        });
        if (this.paperIndex == this.paperData.length - 1) {
          this.formVisible = false;
          this.$message({
            message: "已全部评分完成！",
            type: "success"
          });
        } else {
          this.paperIndex++;
        }
      } catch (e) {}
    }
  }
};
</script>
<style scoped lang="less">
.score-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  margin-bottom: 12px;
  background-color: #fafafa;
  padding: 12px;
  div {
    margin-right: 20px;
  }
  .header-label {
    font-weight: bold;
    margin: 0;
  }
}
.question-box {
  background-color: #fafafa;
  padding: 12px;
  font-size: 16px;
  margin-bottom: 20px;
  line-height: 32px;
  > div {
    margin-bottom: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/TestManage/ScoreDialog.vue